// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-section-controller-wrapper[data-v-0d692772]{margin:0 -24px;padding:6px 12px 8px;overflow:auto;white-space:nowrap;text-align:center}.form-section-controller-wrapper li[data-v-0d692772]{margin:4px 0;-webkit-user-select:none;-moz-user-select:none;user-select:none;padding:4px 12px;cursor:pointer;word-break:keep-all;font-size:14px;border-radius:12px;background:#f3f3f3;display:inline-block;color:#0f4555}", ""]);
// Exports
module.exports = exports;
